import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M10 13c-.571 0-1 .429-1 1s.429 1 1 1 1-.429 1-1-.429-1-1-1zm-.998-7.461L9.478 11h1.045l.476-5.461c.025-.29-.214-.539-.519-.539h-.959c-.305 0-.544.249-.519.539z',
  ],
  height: 20,
  width: 20,
});
